if (!customElements.get('aplus-dimensions')) {
  customElements.define(
    'aplus-dimensions',
    class ApLusDimensions extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-aplus-dimensions-content]');
        // eslint-disable-next-line no-undef
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.handleVariantChange(event));
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      // Every variant's fully resolved (override-or-product-fallback) markup is already
      // pre-rendered server-side into its own <template>, so a switch is a plain clone-and-swap
      // with no fallback logic or fetch re-run on the client.
      handleVariantChange({ data: { variant } }) {
        if (!variant) return;

        const template =
          this.querySelector(`template[data-aplus-dimensions-variant="${variant.id}"]`) ||
          this.querySelector('template[data-aplus-dimensions-variant="__product_level__"]');
        const hasContent = template?.dataset.hasContent === 'true';

        this.hidden = !hasContent;
        if (hasContent) this.content.replaceChildren(template.content.cloneNode(true));
      }
    },
  );
}
